import BackToTopBtn from './BackToTopBtn';

export default BackToTopBtn;
